module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('box', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('form-wizard', {
    attrs: {
      "shape": "square",
      "color": "#20a0ff",
      "error-color": "#ff4949",
      "title": "Cadastro de Novo Usuário",
      "subtitle": "Avance pelas guias para finalizar o cadastro"
    },
    on: {
      "on-complete": _vm.onComplete
    }
  }, [_c('tab-content', {
    attrs: {
      "title": "Dados Pessoais",
      "icon": "fa fa-user",
      "before-change": _vm.validateFirstStep
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-form-inline",
    attrs: {
      "model": _vm.dadosPessoais,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "User Name",
      "prop": "userName"
    }
  }, [_c('div', {
    staticClass: "input-group input-group-lg"
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "sizing-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dadosPessoais.userName),
      expression: "dadosPessoais.userName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Nome de usuário",
      "aria-describedby": "sizing-addon1"
    },
    domProps: {
      "value": (_vm.dadosPessoais.userName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dadosPessoais, "userName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "Foto",
      "prop": "img"
    }
  }, [_c('div', {
    staticClass: "input-group input-group-lg"
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "sizing-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-image-o",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "id": "file-input"
    }
  })])])], 1)], 1), _vm._v(" "), _c('tab-content', {
    attrs: {
      "title": "Credenciais",
      "icon": "fa fa-lock",
      "before-change": _vm.validateSecondStep
    }
  }, [_c('el-form', {
    ref: "ruleFormLogin",
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "model": _vm.dadosLogin,
      "rules": _vm.rulesLogin
    }
  }, [_c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "Email para Login",
      "prop": "email"
    }
  }, [_c('div', {
    staticClass: "input-group input-group-lg"
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "sizing-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dadosLogin.email),
      expression: "dadosLogin.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Email",
      "aria-describedby": "sizing-addon1"
    },
    domProps: {
      "value": (_vm.dadosLogin.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dadosLogin, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "Senha de Acesso",
      "prop": "password"
    }
  }, [_c('div', {
    staticClass: "input-group input-group-lg"
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "sizing-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-key"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dadosLogin.password),
      expression: "dadosLogin.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Senha de Acesso",
      "aria-describedby": "sizing-addon1"
    },
    domProps: {
      "value": (_vm.dadosLogin.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dadosLogin, "password", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "Empresas",
      "prop": "fullName"
    }
  }, [_c('multi-select', {
    attrs: {
      "options": _vm.options,
      "selected-options": _vm.dadosLogin.itens,
      "placeholder": "Empresas com permissão"
    },
    on: {
      "select": _vm.onSelect
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('tab-content', {
    attrs: {
      "title": "Confirmar Dados",
      "icon": "fa fa-check"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_vm._v("\n                        Nome de Usuário: \n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.dadosPessoais.userName
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_vm._v("\n                        Email: \n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.dadosLogin.email
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_vm._v("\n                        Senha: \n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "password",
      "type": "password",
      "disabled": ""
    },
    domProps: {
      "value": _vm.dadosLogin.password
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.mostrandoSenha),
      expression: "!mostrandoSenha"
    }],
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.mostrarSenha('mostrar')
      }
    }
  }, [_c('span', {
    staticClass: "badge"
  }, [_vm._v("Mostrar Senha")])]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mostrandoSenha),
      expression: "mostrandoSenha"
    }],
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.mostrarSenha('')
      }
    }
  }, [_c('span', {
    staticClass: "badge"
  }, [_vm._v("Ocultar Senha")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_vm._v("\n                        Empresas: \n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.empresas
    }
  })])])]), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn-primary",
    attrs: {
      "slot": "prev",
      "type": "primary"
    },
    slot: "prev"
  }, [_vm._v("Anterior")]), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn-primary",
    attrs: {
      "slot": "next",
      "type": "primary"
    },
    slot: "next"
  }, [_vm._v("Próximo")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.gravando),
      expression: "!gravando"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "slot": "finish",
      "type": "primary"
    },
    slot: "finish"
  }, [_vm._v("Confirmar")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.gravando),
      expression: "gravando"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "slot": "finish",
      "type": "primary",
      "disabled": ""
    },
    slot: "finish"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v("Confirmar")])], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3aa30c66"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/NovoUsuario.vue
// module id = 1230
// module chunks = 1